import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Jeff Anders
 * id 957ED765-1CC2-4C07-959B-065465917872
 * name invoice-text-clock-outline
 * version: 7.4.47
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/invoice-text-clock-outline.svg
 * tags
 * - Banking 
 * - Shopping 
 */
export const InvoiceTextClockOutlineIcon = createSvgIcon(<><path d="M17 9H7V7H17V9M15 13V16.69L18.19 18.53L18.94 17.23L16.5 15.82V13H15M9 22L10.87 20.76C12.14 22.14 13.97 23 16 23C19.87 23 23 19.87 23 16C23 14.09 22.24 12.36 21 11.1V3H3V22L6 20L9 22M9 19.6L6 17.6L5 18.26V5H19V9.67C18.09 9.24 17.07 9 16 9C14.09 9 12.36 9.76 11.1 11H7V13H9.67C9.24 13.91 9 14.93 9 16C9 17.12 9.26 18.17 9.73 19.11L9 19.6M16 21C13.24 21 11 18.76 11 16C11 13.24 13.24 11 16 11C18.76 11 21 13.24 21 16C21 18.76 18.76 21 16 21Z" /></>, 'InvoiceTextClockOutlineIcon');
export default InvoiceTextClockOutlineIcon